<template>
    <div class="center-box powerStation-center ps-left">
        <title1 title="站点信息" :isBg="false" fontSize="32" />
        <div
            v-for="(item, i) in target1"
            :key="'target1' + i"
            class="flex align-center target4">
            <img class="img" :src="item.icon" />
            <div class="flex flex-direction">
                <div class="label">{{ item.label}}</div>
                <div class="num flex align-center fs-center" :style="{'color': item.color}">
                    <slot v-if="item.overTenThousand">{{ item.number | overTenThousandUnit }}</slot>
                    <slot v-else>{{ item.number }}</slot>
                </div>
                <!-- <div class="num" :style="{'color': item.color}">{{ item.number }}</div> -->
                <!-- <dv-digital-flop class="num" :config="dvDigitalFlopConfig(item)" /> -->
            </div>
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
export default {
    components: {
        title1
    },
    props: {
        target: {
            type: Array,
            default: () => { return [] }
        }
    },
    watch: {
        target(val) {
            this.target1 = val
        }
    },
    data() {
        return {
            target1: this.target 
        }
    },
    methods: {
        dvDigitalFlopConfig(item = {}) {
            let number = parseFloat(item.number || 0)
            let config = {
                number: [parseInt(number > 10000 ? (number / 10000) : number)],
                textAlign: item.textAlign || 'left',
                content: number > 10000 ? '{nt}w' : '{nt}',
                style: {
                    fill: item.color || '#fff',
                    fontSize: item.fontSize || 60,
                }
            }
            return config
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/chd-com.scss';
</style>